"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = WizardSelectStep;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _GenericStore = require("../store/GenericStore");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid/Grid"));

var _Component = _interopRequireDefault(require("../../render/Component"));

var _reactI18next = require("react-i18next");

var _Context = _interopRequireDefault(require("../../Context"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%'
    },
    button: {
      width: '90%',
      margin: '0px',
      marginTop: '30px'
    },
    bottom: {
      width: '100%',
      textAlign: 'center !important',
      margin: '0px',
      marginTop: '10px',
      padding: '0px',
      paddingBottom: '20px'
    },
    body: {
      padding: '20px',
      paddingTop: '60px'
    },
    title: {
      fontFamily: 'FSMEWebBold',
      fontSize: '1.2em',
      fontWeight: '600',
      textAlign: 'center'
    }
  };
});

function WizardSelectStep(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useContext = (0, _react.useContext)(_Context["default"]),
      onCancel = _useContext.onCancel,
      onNext = _useContext.onNext;

  (0, _react.useEffect)(function () {});
  var classes = useStyles();
  var block = props.block,
      parentPath = props.parentPath;
  var selectors = block.content;

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      value = _useDataStore2[0],
      setValue = _useDataStore2[1];

  var addLineBreaks = function addLineBreaks(string) {
    return string.split('\n').map(function (text, index) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "".concat(text, "-").concat(index)
      }, text, /*#__PURE__*/_react["default"].createElement("br", null));
    });
  };

  var handleChange = function handleChange(selectorInd) {
    setValue(selectors[selectorInd].value);
    console.log('parentPath: ', parentPath, 'value: ', selectors[selectorInd].value);
    if (block.isFinal) onCancel.onCancel();else onNext.onNext();
  };

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.body
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.title
  }, addLineBreaks(t(block.label)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.bottom
  }, selectors.map(function (component, ind) {
    return /*#__PURE__*/_react["default"].createElement(_Fab["default"], {
      variant: "extended",
      color: "primary",
      onClick: function onClick() {
        return handleChange(ind);
      },
      className: classes.button,
      key: parentPath + component.label
    }, t(component.label));
  })));
}